let RawType;
(function (RawType) {
    RawType["Array"] = "Array";
    RawType["String"] = "String";
})(RawType || (RawType = {}));
const _toString = Object.prototype.toString;
const _object = 'object';
const toRawType = (target) => _toString.call(target).slice(8, -1);
const isArray = Array.isArray ? Array.isArray : (target) => toRawType(target) === RawType.Array;
const isString = (target) => toRawType(target) === RawType.String;
const isObject = (target) => target !== null && typeof target === _object;

class Trie {
    constructor(list) {
        this.endTag = '||';
        this.head = {};
        if (list) {
            const length = list.length;
            for (let index = 0; index < length; index += 1) {
                this.insert(list[index]);
            }
        }
    }

    insert(word) {
        let node = this.head;
        const length = word.length;
        for (let index = 0; index < length; index += 1) {
            const char = word[index];
            if (char in node) {
                node = node[char];
            } else {
                const child = {};
                node[char] = child;
                node = child;
            }
        }
        node[this.endTag] = true;
    }

    containsSomeWord(str) {
        const headNode = this.head;
        const length = str.length;
        for (let i = 0; i < length; i += 1) {
            const char = str[i];
            if (char in headNode) {
                const contains = this.walk(str.substr(i));
                if (contains) {
                    return true;
                }
            }
        }
        return false;
    }

    walk(str) {
        const endTag = this.endTag;
        let node = this.head;
        const length = str.length;
        for (let index = 0; index < length; index += 1) {
            const char = str[index];
            if (char in node) {
                node = node[char];
                if (endTag in node) {
                    return true;
                }
            } else {
                return false;
            }
        }
        return false;
    }
}

class Filter {
    constructor(list, wildcard = '*') {
        this.trie = new Trie(list);
        this.wildcard = wildcard;
    }

    checkInTrie(val, isStrict) {
        let str;
        if (isString(val)) {
            str = val;
        } else {
            if (isStrict) {
                return false;
            } else {
                str = String(val);
            }
        }
        return this.trie.containsSomeWord(str);
    }

    checkTarget(target, key, isStrict, isBase) {
        // 当该项不是基准，且匹配敏感词时需要父级中的基准对象作删除该项处理
        let toDelete = false;
        if (isObject(target)) {
            if (key !== this.wildcard) {
                if (this.checkInTrie(target[key], isStrict)) {
                    if (isBase) {
                        if (isArray(target)) {
                            target.splice(key, 1);
                        } else {
                            target[key] = '';
                        }
                    } else {
                        toDelete = true;
                    }
                }
            } else {
                if (isArray(target)) {
                    let i = 0;
                    const array = target;
                    while (i < array.length) {
                        if (this.checkInTrie(array[i], isStrict)) {
                            if (isBase) {
                                array.splice(i, 1);
                            } else {
                                toDelete = true;
                                break;
                            }
                        } else {
                            i += 1;
                        }
                    }
                } else {
                    for (const k in target) {
                        if (target.hasOwnProperty(k)) {
                            if (this.checkInTrie(target[k], isStrict)) {
                                if (isBase) {
                                    target[k] = '';
                                } else {
                                    toDelete = true;
                                }
                            }
                        }
                    }
                }
            }
        }
        return toDelete;
    }

    trace(obj, pathArr, fromIndex, endIndex, baseIndex, isStrict) {
        let toDelete = false;
        const isBase = fromIndex === baseIndex;
        if (obj && fromIndex <= endIndex) {
            const key = pathArr[fromIndex];
            const nextIndex = fromIndex + 1;
            if (fromIndex < endIndex) {
                if (key !== this.wildcard) {
                    if (this.trace(obj[key], pathArr, nextIndex, endIndex, baseIndex, isStrict)) {
                        if (isBase) {
                            if (isArray(obj)) {
                                obj.splice(key, 1);
                            } else {
                                obj[key] = '';
                            }
                        } else {
                            toDelete = true;
                        }
                    }
                } else if (isObject(obj)) {
                    if (isArray(obj)) {
                        let i = 0;
                        while (i < obj.length) {
                            if (this.trace(obj[i], pathArr, nextIndex, endIndex, baseIndex, isStrict)) {
                                if (isBase) {
                                    obj.splice(i, 1);
                                } else {
                                    i += 1;
                                    toDelete = true;
                                }
                            } else {
                                i += 1;
                            }
                        }
                    } else {
                        for (const k in obj) {
                            if (obj.hasOwnProperty(k)) {
                                if (this.trace(obj[k], pathArr, nextIndex, endIndex, baseIndex, isStrict)) {
                                    if (isBase) {
                                        obj[k] = '';
                                    } else {
                                        toDelete = true;
                                    }
                                }
                            }
                        }
                    }
                }
            } else {
                toDelete = this.checkTarget(obj, key, isStrict, (baseIndex < 0) || isBase);
            }
        }
        return toDelete;
    }

    filterWithPath(target, path, isStrict = true) {
        if (isString(path)) {
            const pathArr = path.split('.');
            const length = pathArr.length;
            const lastIndex = pathArr.length - 1;
            let index = length;
            let item;
            const leftBracket = '(', rightBracket = ')';
            while (index--) {
                item = pathArr[index];
                if (item[0] === leftBracket && item[item.length - 1] === rightBracket) {
                    pathArr[index] = item.slice(1, -1);
                    break;
                }
            }
            this.trace(target, pathArr, 0, lastIndex, index, isStrict);
        } else if (isArray(path)) {
            const lastIndex = path.length - 1;
            let index = lastIndex;
            let item;
            while (index--) {
                item = path[index];
                if (isObject(item) && item.isBase) {
                    path[index] = item.val;
                    break;
                }
            }
            this.trace(target, path, 0, lastIndex, index, isStrict);
        }
    }

    filterWithPaths(target, paths, isStrict) {
        const size = paths.length;
        let index = 0;
        while (index < size) {
            this.filterWithPath(target, paths[index], isStrict);
            index += 1;
        }
    }
}

export default Filter;
